import React from 'react'

const PrimaryPOSIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect
                x="3"
                y="4"
                width="18"
                height="16"
                rx="2"
                stroke="#E07839"
                strokeWidth="2"
            />
            <path
                d="M3 10H21"
                stroke="#E07839"
                strokeWidth="2"
            />
            <path
                d="M7 15H10"
                stroke="#E07839"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M14 15H17"
                stroke="#E07839"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default PrimaryPOSIcon

